import React from 'react';
import { Skeleton } from '../../../components/ui/skeleton';

export const CourseSkeleton: React.FC = () => {
    return (
        <div className="container mx-auto py-8">
            {/* Header Skeleton */}
            <div className="mb-8 space-y-4">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-10 w-full max-w-2xl" />
                <Skeleton className="h-6 w-96" />
                <div className="flex gap-4 pt-4">
                    <Skeleton className="h-10 w-32" />
                    <Skeleton className="h-10 w-32" />
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                {/* Main Content Skeleton */}
                <div className="lg:col-span-2 space-y-8">
                    <Skeleton className="h-[400px] w-full rounded-xl" />
                    <div className="space-y-4">
                        <Skeleton className="h-12 w-full" />
                        <Skeleton className="h-32 w-full" />
                        <Skeleton className="h-32 w-full" />
                    </div>
                </div>

                {/* Sidebar Skeleton */}
                <div className="space-y-6">
                    <Skeleton className="h-[300px] w-full rounded-xl" />
                    <Skeleton className="h-40 w-full rounded-xl" />
                </div>
            </div>
        </div>
    );
};
